<template>
  <div class="flex flex-wrap gap-2 mb-4">
    <span class="text-sm text-gray-600 mr-2">{{ $t("reports.filters.quick_dates") }}:</span>
    <Button
      v-for="preset in presets"
      :key="preset.key"
      :class="[
        'text-xs px-3 py-1 rounded-md transition-colors',
        selectedPreset === preset.key 
          ? 'bg-primary-500 text-white' 
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      ]"
      @click="selectPreset(preset.key)"
      :label="preset.label"
    />
  </div>
</template>

<script>
import { Button } from 'primevue';
import moment from 'moment';

export default {
  name: 'FilterQuickDates',
  components: {
    Button
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      selectedPreset: '',
      presets: [
        { key: 'today', label: this.$t('reports.filters.presets.today') },
        { key: 'yesterday', label: this.$t('reports.filters.presets.yesterday') },
        { key: 'last7days', label: this.$t('reports.filters.presets.last_7_days') },
        { key: 'last30days', label: this.$t('reports.filters.presets.last_30_days') },
        { key: 'thisMonth', label: this.$t('reports.filters.presets.this_month') },
        { key: 'lastMonth', label: this.$t('reports.filters.presets.last_month') }
      ]
    };
  },
  methods: {
    selectPreset(presetKey) {
      this.selectedPreset = presetKey;
      this.$emit('update:modelValue', presetKey);
      this.$emit('change', presetKey);
    },
    getPresetDates(presetKey) {
      let from, to;
      
      switch (presetKey) {
        case 'today':
          from = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
          to = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
          break;
        case 'yesterday': {
          const yesterday = moment().subtract(1, 'day');
          from = yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss');
          to = yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss');
          break;
        }
        case 'last7days': {
          const last7Days = moment().subtract(7, 'days');
          from = last7Days.startOf('day').format('YYYY-MM-DD HH:mm:ss');
          to = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
          break;
        }
        case 'last30days': {
          const last30Days = moment().subtract(30, 'days');
          from = last30Days.startOf('day').format('YYYY-MM-DD HH:mm:ss');
          to = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
          break;
        }
        case 'thisMonth':
          from = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
          to = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
          break;
        case 'lastMonth': {
          const lastMonth = moment().subtract(1, 'month');
          from = lastMonth.startOf('month').format('YYYY-MM-DD HH:mm:ss');
          to = lastMonth.endOf('month').format('YYYY-MM-DD HH:mm:ss');
          break;
        }
        default:
          from = moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
          to = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
      
      return { from, to };
    }
  },
  watch: {
    modelValue(newValue) {
      this.selectedPreset = newValue;
    }
  }
};
</script> 